<template>
  <div class="Ph_home">
    <Banner />
    <FantasyNews />
    <CharacterIntroduction />
    <AudiovisualFeast />
    <FootSwiper />
    <Footer />
    <!-- <Footer /> -->
    <!--回顾活动结束注释该代码-->
    <!-- <div class="annual_summary_icon">
      <img
        class="redEnvelopes"
        src="@/assets/annualSummary/f_icon.png"
        @click="goAnnualSummary"
      />
    </div> -->
  </div>
</template>

<script>
import Banner from "./models/Banner";
import FantasyNews from "./models/FantasyNews";
import CharacterIntroduction from "./models/CharacterIntroduction";
import AudiovisualFeast from "./models/AudiovisualFeast";
import FootSwiper from "./models/FootSwiper";
import Footer from "@/components/MobileFloor";
export default {
  name: "PhHome",
  components: {
    Banner,
    FantasyNews,
    CharacterIntroduction,
    AudiovisualFeast,
    Footer,
    FootSwiper,
  },
  mounted() {
    this.$nextTick(() => {
      const top = this.$route.query.y;
      if (top) {
        document.documentElement.scrollTop = top;
        document.body.scrollTop = top;
      }
    });
  },
  methods:{
    goAnnualSummary() {
      this.$router.push({
          path: "/AnnualSummary",
          // query: {
          //   l: "l",
          //   oldP: this.$route.fullPath,
          // },
        });
    },
  }
};
</script>

<style lang="scss" scoped>
@keyframes scaleDraw {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.1);
  }
}
.redEnvelopes {
  width: 91.7px;
  height: 101.5px;
  object-fit: contain;
  // height: 200px;
  // background: url('~@/assets/change/newImg5.jpg');
  -webkit-animation-name: scaleDraw;
  /*关键帧名称*/
  -webkit-animation-timing-function: ease-in-out;
  /*动画的速度曲线*/
  -webkit-animation-iteration-count: infinite;
  /*动画播放的次数*/
  -webkit-animation-duration: 4s;
  /*动画所花费的时间*/
  animation-name: scaleDraw;
  /*关键帧名称*/
  animation-timing-function: ease-in-out;
  /*动画的速度曲线*/
  animation-iteration-count: infinite;
  /*动画播放的次数*/
  animation-duration: 4s;
  /*动画所花费的时间*/
}
.annual_summary_icon {
  //position: absolute;
  top:65px;
  right:0px;
  position: fixed;
  z-index: 1001;
  display: flex;
}
</style>
